import { render } from "./period-picker-months.vue?vue&type=template&id=ae4e4624"
import script from "./period-picker-months.vue?vue&type=script&lang=js"
export * from "./period-picker-months.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__